<template>
  <div
    id="ordering-step"
    :class="{ step3: currentPageOrderStatus >2 && currentPageOrderStatus !== 10 }"
  >
    <div class="fliggy-order-info-bar-box" v-if="order.ota_info">
      <fliggy-order-info-bar :ota-info="order.ota_info"></fliggy-order-info-bar>
    </div>
    <!-- 步骤条 -->
    <div class="steps clearfix" v-if="order.user_order_id">
      <div
        class="step upload"
        :class="[
          { active: step.orderStatus === currentPageOrderStatus, disabled: step.orderStatus !== currentPageOrderStatus && (step.disabled || disabled) },
          { future: step.future },
          { 'four-step': steps.length === 4 },
          step.className
        ]"
        v-for="(step, index) in steps"
        :key="step.className"
        @click="jumpStep(step)"
      >
        <div class="icon">{{ index + 1 }}</div>
        <div class="title">{{ step.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import orderingService from '../../../services/ordering-service';
import FliggyOrderInfoBar from '@/components/ota/fliggy-order-info-bar.vue';

export default {
  name: 'ordering-step',
  components: {
    FliggyOrderInfoBar,
  },
  props: {
    // 订单信息
    order: {
      type: Object,
      required: true,
      default: () => ({}),
    },

    // 当前页面对应的订单状态
    currentPageOrderStatus: {
      type: Number,
      required: true,
      default: 0,
    },

    // 禁用进度条
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      steps: orderingService.getOrderSteps(this.order),
    };
  },
  watch: {
    order(newVal) {
      if (newVal.user_order_id) {
        this.steps = orderingService.getOrderSteps(newVal);
      }
    },
    'order.order_status': function () {
      if (this.order.user_order_id) {
        this.steps = orderingService.getOrderSteps(this.order);
      }
    },
  },
  methods: {
    jumpStep(step) {
      if (step.orderStatus === this.currentPageOrderStatus || step.disabled || this.disabled) {
        return;
      }
      this.$router.push(step.routeConfig);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";
#ordering-step {
  background-color: white;
  font-size: 0;
  text-align: center;
  min-height: 0;
  margin-bottom: 10px;
  position: relative;
  .fliggy-order-info-bar{
    padding: 20px 30px 6px 30px;
  }
  &.step3 {
    margin: 0;
  }

  .steps {
    display: inline-block;
    text-align: center;
    position: relative;
    padding: 14px 0;

    &::before {
      content: "";
      display: block;
      border-bottom: 1px dashed #dedede;
      position: absolute;
      z-index: 1;
      top: 26px;
      left: 50px;
      right: 50px;
    }
  }

  .step {
    position: relative;
    z-index: 2;
    float: left;
    cursor: pointer;
    & + .step {
      margin-left: 250px;
    }

    & + .four-step {
      margin-left: 170px;
    }
  }

  .icon {
    width: 24px;
    height: 24px;
    margin: 0 auto;
    border-radius: 50%;
    border: 1px solid #6f6f6f;
    background-color: white;
    text-align: center;
    line-height: 22px;
    color: #444;
    font-size: 14px;
  }

  .title {
    font-size: 14px;
    color: #444;
    margin-top: 10px;
  }

  .step.active {
    cursor: default;
    .icon {
      border-color: @main;
      background-color: @main;
      color: white;
    }

    .title {
      color: @main;
    }
  }

  .step.disabled {
    cursor: not-allowed;
    .icon {
      border-color: #d0d0d0;
      color: #aaa;
    }
    .title {
      color: #aaa;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/ordering-step.vue